// Second, named Firebase app instance pointed at the `malaeb-chat` RTDB project.
// This is a DIFFERENT Firebase project from `src/config/firebase.config.ts`
// (which is `malaeb-business`, used for Analytics/Functions only) — do not merge them.
import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getDatabase, Database } from 'firebase/database';
import { getStorage, FirebaseStorage } from 'firebase/storage';

const chatFirebaseConfig = {
  apiKey: process.env.REACT_APP_CHAT_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_CHAT_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_CHAT_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_CHAT_FIREBASE_PROJECT_ID,
  appId: process.env.REACT_APP_CHAT_FIREBASE_APP_ID,
  messagingSenderId: process.env.REACT_APP_CHAT_FIREBASE_MESSAGING_SENDER_ID,
  storageBucket: process.env.REACT_APP_CHAT_FIREBASE_STORAGE_BUCKET,
};

// databaseURL is required for the RTDB SDK to initialize. If chat config is
// missing (e.g. prod credentials not yet provisioned, see plan §2.1), skip
// initialization entirely so the rest of the dashboard keeps working — the
// topbar icon must still render with no badge rather than crash (PRD §9).
const isChatConfigured = Boolean(chatFirebaseConfig.databaseURL && chatFirebaseConfig.apiKey);

let chatApp: FirebaseApp | null = null;
let chatAuth: Auth | null = null;
let chatDb: Database | null = null;
let chatStorage: FirebaseStorage | null = null;

if (isChatConfigured) {
  chatApp = initializeApp(chatFirebaseConfig, 'chat');
  chatAuth = getAuth(chatApp);
  chatDb = getDatabase(chatApp);
  chatStorage = getStorage(chatApp);
} else if (process.env.NODE_ENV !== 'test') {
  // eslint-disable-next-line no-console
  console.warn('[chat] REACT_APP_CHAT_FIREBASE_* env vars are not set — chat is disabled.');
}

export { chatApp, chatAuth, chatDb, chatStorage, isChatConfigured };
